import { Brand } from '@shopby/shop-sdk'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { Grid, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getBrands } from '../../api/product'
import { fadeIn, fadeOut, slideLeft, slideRight } from '../../js/animation'
import { plusComma } from '../../js/script'
import { RecentSearch, RecentSearchContent } from '../../pages/search/Search'
import { TwoDepContent } from '../modals/ModalCategory'
import MultiRangeSlider from '../MultiRangeSilder'

// 이미지 경로
const imgURL = '/images'
interface PropsType {
  isCategoryModal: boolean
  setIsCategoryModal: React.Dispatch<React.SetStateAction<boolean>>
  setFreeCheck: React.Dispatch<React.SetStateAction<boolean>>
  setGetMax: React.Dispatch<React.SetStateAction<any>>
  setGetMin: React.Dispatch<React.SetStateAction<any>>
  setFilterApply: React.Dispatch<React.SetStateAction<boolean>>
  setBrandArray: React.Dispatch<React.SetStateAction<any>>
  brandArray: any
  freeCheck?: boolean
  max?: number
  min?: number
  setMax?: any
  setMin?: any
  filterMax?: number
  filterMin?: number
}

type CheckBrandArray = {
  id: number
  label: string
}

export default function ProductFilterModal({
  setIsCategoryModal,
  isCategoryModal,
  setFreeCheck,
  setGetMax,
  setGetMin,
  setFilterApply,
  setBrandArray,
  brandArray,
  freeCheck,

  max,
  min,
  setMax,
  setMin,
  filterMax,
  filterMin,
}: PropsType) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [checkBrandArray, setCheckBrandArray] = useState<CheckBrandArray[]>([])
  const [value, setValue] = React.useState<number[]>([0, 10000000])
  const [freeCheckName, setFreeCheckName] = useState<boolean>(false)
  const [brandArrayCopy, setBrandArrayCopy] = useState<any>([])
  const [maxValue, setMaxValue] = useState<number>(10000000)
  const [minValue, setMinValue] = useState<number>(0)
  const [priceChange, setPriceChange] = useState<boolean>(false)
  const [apply, setApply] = useState<boolean>(false)
  const [reset, setReset] = useState<boolean>(false)
  const [brandItem, setBrandItem] = useState<Brand[]>([])
  const location = useLocation()
  const minValInputRef = useRef<any>(null)
  const maxValInputRef = useRef<any>(null)

  const handleSliderChange = (values: { min: number; max: number }) => {}

  useEffect(() => {
    if (freeCheck) {
      setFreeCheckName(freeCheck)
    }
  }, [freeCheck])

  useEffect(() => {
    const copy = [...brandArray]
    setBrandArrayCopy(copy)
  }, [brandArray])

  useEffect(() => {
    // 먼저 배열을 초기화
    setCheckBrandArray([])

    brandItem.forEach((el: any) => {
      for (let i = 0; i < brandArray.length; i++) {
        if (Number(brandArray[i]) === Number(el.brandNo)) {
          const obj = { id: el.brandNo, label: el.name }
          // 배열을 누적
          setCheckBrandArray((prev: any) => [...prev, obj])
        }
      }
    })
  }, [brandItem, brandArray])

  useEffect(() => {
    if (minValue !== 0 || maxValue !== 10000000) {
      setPriceChange(true)
    } else {
      setPriceChange(false)
    }
  }, [minValue, maxValue])

  const handleReset = () => {
    setReset(true)
    setValue([0, 10000000])
    minValInputRef.current.classList.remove('on')
    maxValInputRef.current.classList.remove('on')
  }

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      document.getElementsByTagName('body')[0].style.overflow = ''
      setIsCategoryModal(false)
      setClosing(false)
    }, 280)
  }

  useEffect(() => {
    setGetMin(minValue)
  }, [minValue])

  useEffect(() => {
    setGetMax(maxValue)
  }, [maxValue])

  useEffect(() => {
    if (isCategoryModal) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    }
  }, [isCategoryModal])

  useEffect(() => {
    getBrands().then((res) => {
      setBrandItem(res.data.items)
    })
  }, [location])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  if (!isCategoryModal) return null
  return (
    <>
      <ModalWrap closing={closing}>
        {/* 헤더 */}
        <ModalHeader>
          <p>필터</p>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt='닫기' />
          </button>
        </ModalHeader>
        <ModalBody>
          <FilterValueWrap>
            {checkBrandArray.length !== 0 || freeCheckName || priceChange ? (
              <div>
                {checkBrandArray.map((el: any, index: number) => {
                  return (
                    <RecentSearchContent key={index}>
                      <RecentSearch>{el.label}</RecentSearch>
                      <img
                        src='/images/icon_search_delete_gray.svg'
                        alt='선택 필터 삭제'
                        onClick={() => {
                          const array: any[] = []
                          const nameArray: any[] = []
                          brandArrayCopy.map((element: any) => {
                            if (Number(el.id) === Number(element)) {
                              if (brandArrayCopy.length === 1) {
                                setBrandArrayCopy([])
                                setCheckBrandArray([])
                              }
                            } else {
                              array.push(element)
                            }
                            setBrandArrayCopy(array)
                          })
                          checkBrandArray.map((element: any) => {
                            if (el.label === element.label) {
                              if (brandArrayCopy.length === 1) {
                                setBrandArrayCopy([])
                                setCheckBrandArray([])
                              }
                            } else {
                              nameArray.push(element)
                            }
                            setCheckBrandArray(nameArray)
                          })
                        }}
                      />
                    </RecentSearchContent>
                  )
                })}
                {freeCheckName ? (
                  <RecentSearchContent>
                    <RecentSearch>무료배송</RecentSearch>
                    <img
                      src='/images/icon_search_delete_gray.svg'
                      alt='선택 필터 삭제'
                      onClick={() => {
                        setFreeCheckName(false)
                        setFreeCheck(false)
                      }}
                    />
                  </RecentSearchContent>
                ) : null}
                {priceChange ? (
                  <RecentSearchContent>
                    <RecentSearch>{`${plusComma(minValue)}원 ~ ${plusComma(maxValue)}원`}</RecentSearch>
                    <img
                      src='/images/icon_search_delete_gray.svg'
                      alt='선택 필터 삭제'
                      onClick={() => {
                        setReset(true)
                        setGetMax(10000000)
                        setGetMin(0)
                        setMax(10000000)
                        setMin(0)
                        setPriceChange(false)
                      }}
                    />
                  </RecentSearchContent>
                ) : null}
              </div>
            ) : null}
          </FilterValueWrap>
          <FilterWrap>
            <BrandWrap style={{ gap: 0 }}>
              <TwoDepContent style={{ paddingBottom: '16px' }}>브랜드</TwoDepContent>
              <BrandCententWrap>
                <BrandFlexWrap>
                  <Swiper
                    slidesPerView={2}
                    centeredSlides={false}
                    slidesPerGroup={2}
                    slidesPerGroupAuto={false}
                    slidesPerGroupSkip={0}
                    grid={{
                      rows: 5,
                      fill: 'row',
                    }}
                    spaceBetween={20}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[Grid, Pagination]}
                    className='filter_swiper'
                  >
                    {brandItem.map((el: any, index: number) => {
                      return (
                        <SwiperSlide key={index}>
                          <FilterBrand
                            name={el.name}
                            idName={el.brandNo}
                            key={el.categoryNo}
                            setBrandArray={setBrandArrayCopy}
                            brandArray={brandArrayCopy}
                            setCheckBrandArray={setCheckBrandArray}
                            checkBrandArray={checkBrandArray}
                            setBrandArrayCopy={setBrandArrayCopy}
                          ></FilterBrand>
                          {/* <FilterBrand
                        name={el.label}
                        idName={el.categoryNo}
                        key={el.categoryNo}
                        setBrandArray={setBrandArray}
                        brandArray={brandArray}
                        setCheckBrandArray={setCheckBrandArray}
                        checkBrandArray={checkBrandArray}
                      ></FilterBrand> */}
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                </BrandFlexWrap>
              </BrandCententWrap>
            </BrandWrap>
            {/* <DeliveryWrap>
              <TwoDepContent style={{ marginBottom: '16px' }}>배송비</TwoDepContent>
              <DeliveryFree
                name={'무료배송'}
                setFreeCheckName={setFreeCheckName}
                freeCheckName={freeCheckName}
                idName='freeDelivery'
              ></DeliveryFree>
            </DeliveryWrap> */}
            <TwoDepContent style={{ marginTop: '20px', paddingBottom: '8px' }}>가격</TwoDepContent>
            <PriceWrap>
              <MultiRangeSlider
                min={min}
                max={max}
                setMaxValue={setMaxValue}
                setMinValue={setMinValue}
                reset={reset}
                setReset={setReset}
                onChange={handleSliderChange}
                filterMin={filterMin}
                filterMax={filterMax}
                minValInputRef={minValInputRef}
                maxValInputRef={maxValInputRef}
              ></MultiRangeSlider>
            </PriceWrap>
          </FilterWrap>
        </ModalBody>
        <ModalFooter>
          <CartBtnLeft
            disabled={freeCheckName || freeCheck || checkBrandArray.length !== 0 || priceChange ? false : true}
            onClick={() => {
              setFreeCheckName(false)
              setFreeCheck(false)
              setPriceChange(false)
              handleReset()
              setBrandArray([])
              setCheckBrandArray([])
              setReset(true)
            }}
          >
            초기화
          </CartBtnLeft>
          <CartBtnRight
            onClick={() => {
              setApply(true)
              setFilterApply(true)
              setFreeCheck(freeCheckName)
              setIsCategoryModal(false)
              closeModal()
              setBrandArray(brandArrayCopy)
              setFreeCheck(freeCheckName ? true : false)
            }}
          >
            적용하기
          </CartBtnRight>
        </ModalFooter>
      </ModalWrap>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </>
  )
}

interface filterName {
  name: string
  idName?: string
  setFreeCheckName?: any
  freeCheckName: boolean
}

function DeliveryFree({ name, idName, setFreeCheckName, freeCheckName }: filterName) {
  const [isChecked, setIsChecked] = useState(false)
  useEffect(() => {
    setIsChecked(freeCheckName)
  }, [freeCheckName])
  const toggleCheckbox = () => {
    setIsChecked(!isChecked)
    setFreeCheckName((prev: any) => !prev)
  }

  return (
    <BrandContent>
      <Checkbox checked={isChecked} onChange={toggleCheckbox} idName={idName} />
      <BrandName htmlFor={idName} className={isChecked ? 'on' : ''}>
        {name}
      </BrandName>
    </BrandContent>
  )
}

function FilterBrand({
  name,
  idName,
  setFreeDelivery,
  setBrandArray,
  brandArray,
  setCheckBrandArray,
  checkBrandArray,
}: any) {
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if (brandArray.includes(idName)) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  }, [brandArray])

  const toggleCheckbox = (e: any) => {
    setIsChecked(!isChecked)
    if (!isChecked) {
      if (brandArray.length === 0) {
        setBrandArray([idName])
        setCheckBrandArray([{ label: name, id: idName }])
      } else {
        setBrandArray((prev: number[]) => [...prev, idName])
        setCheckBrandArray((prev: number[]) => [...prev, { label: name, id: idName }])
      }
    } else if (isChecked) {
      const array: number[] = []
      const nameArray: string[] = []
      brandArray.map((el: number) => {
        if (el === idName) {
          if (brandArray.length === 1) {
            setBrandArray([])
            setCheckBrandArray([])
          }
        } else {
          array.push(el)
        }
      })
      checkBrandArray.map((el: any) => {
        if (el.label === name) {
          if (brandArray.length === 1) {
            setBrandArray([])
            setCheckBrandArray([])
          }
        } else {
          nameArray.push(el)
        }
      })
      setBrandArray(array)
      setCheckBrandArray(nameArray)
    }
  }
  return (
    <BrandContent>
      <Checkbox
        checked={isChecked}
        onChange={(e: any) => {
          toggleCheckbox(e)
        }}
        idName={idName}
      />
      <BrandName htmlFor={idName} className={isChecked ? 'on' : ''}>
        {name}
      </BrandName>
    </BrandContent>
  )
}

export const CustomRangeSlider = ({ min, max, step, value, onChange }: any) => {
  const handleChange = (event: any) => {
    const newValue = parseInt(event.target.value)
    onChange(newValue)
  }

  return (
    <input
      type='range'
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={handleChange}
      style={{ width: '80%', display: 'block', margin: '10px auto' }}
    />
  )
}

export function PriceSlider() {
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(100)
  const [sliderValue, setSliderValue] = useState(50)

  const handleSliderChange = (newValue: any) => {
    setSliderValue(newValue)
    if (newValue < minValue) {
      setMinValue(newValue)
    }
    if (newValue > maxValue) {
      setMaxValue(newValue)
    }
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Multi-Range Slider Example</h1>
      <label>
        Min Value: {minValue}
        <br />
        Max Value: {maxValue}
      </label>
      <CustomRangeSlider min={minValue} max={maxValue} step={1} value={sliderValue} onChange={handleSliderChange} />
      <p>Value: {sliderValue}</p>
    </div>
  )
}

/**
 * 모달 팝업 - 메뉴 (좌우 슬라이드)
 */

interface typeProps {
  closing?: boolean
}
export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div<typeProps>`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  animation: ${({ closing }) => (closing ? slideRight : slideLeft)} 0.3s ease-in-out;
  background-color: white;
  z-index: 30;
  & button.btn_close {
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px 0 20px;
  & p {
    color: var(--colBlack);
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
  & button.btn_close {
    width: 48px;
    height: 48px;
    padding: 12px;
    background: none;
    border: none;
  }
`
export const ModalBody = styled.div`
  max-height: calc(100% - 120px);
  overflow: hidden auto;
`

export const FilterWrap = styled.div`
  padding: 0 20px;
`

// 필터 상단 선택된 필터값 영역
export const FilterValueWrap = styled.div`
  & > div {
    box-shadow: inset 0 -1px 0 0 var(--colGray3);
    /* border-bottom: 1px solid var(--colGray3); */
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    padding: 8px 20px 16px 20px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
`

export const BrandWrap = styled.div`
  padding: 20px 0;
  display: block;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px 0;
  min-height: 245px;
  border-bottom: 1px solid var(--colGray3);
`

export const BrandCententWrap = styled.div``

export const BrandFlexWrap = styled.div``

export const BrandContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0 8px;
`

export const BrandName = styled.label`
  font-size: 15px;
  line-height: 20px;
  color: var(--colGray6);
  font-weight: 500;
  white-space: nowrap;
  &.on {
    color: var(--colBlack);
  }
`

const CheckboxContainer = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  /* checkbox를 보이지 않게 함 */
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 0;
`

const StyledCheckbox = styled.div<{ checked: boolean }>`
  /* 기본 체크박스 모양 정의 */
  display: inline-block;
  background: ${(props) =>
    props.checked ? 'url(/images/icon_checkbox_checked.png)' : 'url(/images/icon_checkbox.png)'};
  // props.checked ? "var(--colBlack)" : "var(--colWhite)"};
  background-size: cover;
  background-position: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  /* border: 1px solid var(--colGray3); */
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Checkbox = ({ idName, checked, ...props }: any) => (
  <CheckboxContainer>
    <HiddenCheckbox checked={checked} id={idName} {...props} />
    <StyledCheckbox checked={checked} />
  </CheckboxContainer>
)

export const DeliveryWrap = styled.div`
  padding: 0 0 20px 0;
  margin: 16px 0;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  border-bottom: 1px solid #eaeaea;
`
export const PriceWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px 0;
`
export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  position: fixed;
  bottom: 0;
  z-index: 20;
  width: 100%;
  left: 0%;
  padding: 12px 20px;
  background: var(--colWhite);
`
export const CartBtnLeft = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: var(--colBlack);
  background: var(--colWhite);
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  width: 100%;
  height: 48px;
  &:disabled {
    color: var(--colGray5);
    border: 1px solid var(--colGray3);
  }
`
export const CartBtnRight = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  background: var(--colBlack);
  border-radius: 5px;
  width: 100%;
  height: 48px;
  color: var(--colWhite);
  border: none;
`
